/** @jsx jsx */ //please do not remove this implementation because the css will not be loaded without it
import { jsx, css } from "@emotion/react";
import React from "react";
import {
  ItemsTable,
  ReceiptTemplate,
} from "../../Utils/Template/ReceiptTemplate";
import { tableCell } from "../../styles/tableStyles";
import { formatAmount, formatDigits } from "../../Utils/formatNumbers";
import { dateStringTimeConvert } from "../../Utils/titleCaseFunction";

const headData = [
  { value: "Product" },
  // { value: "Batch#" },
  { value: "Qty" },
  { value: "Price" },
  { value: "Total" },
];

const wordBreak = css`
  word-break: break-word;
`;

const SalesReceiptTemplate = ({ products, customer = {} }) => {
  const user_name = `${!customer?.first_name ? "" : customer?.first_name}`;

  const customerDetails = (
    <tbody>
      <tr>
        <td>
          <td data-testid="sale_number">
            <span>
              Receipt#: <strong>{customer.receipt_number}</strong>
            </span>
          </td>
        </td>
        <td>
          <td data-testid="sale_date">
            <span>
              Date:{" "}
              <strong>
  {products?.length > 0 && products[0]?.date
    ? dateStringTimeConvert(products[0].date)
    : ""}
</strong>
            </span>
          </td>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            Name:{" "}
            <strong data-testid="customer">{customer.customer_name}</strong>
          </span>
        </td>
        <td>
          <td data-testid="received_by">
            <span>
              Received by: <strong>{user_name}</strong>
            </span>
          </td>
        </td>
      </tr>
    </tbody>
  );

  // const itemDetails = (
  //   <ItemsTable headData={headData}>
  //     <tbody>
  //       {products.map((info, index) => {
  //         const qty = info.quantity ? info.quantity : 0;
  //         const rate = info.rate ? info.rate : 0;
  //         return (
  //           <tr key={index}>
  //             <td css={[wordBreak]} data-testid={"product_name-" + index}>
  //               <span>{info.product_name}</span>
  //             </td>
  //             {/* <td css={[wordBreak]} data-testid={"batch-" + index}>
  //               <span>{info.batch_id}</span>
  //             </td> */}
  //             <td data-testid={"quantity-" + index}>
  //               <span>{info.quantity}</span>
  //             </td>
  //             <td data-testid={"rate-" + index}>
  //               <span>{info.rate}</span>
  //             </td>
  //             <td data-testid={"total_rate" + index}>
  //               <span>{formatDigits(+qty * +rate)}</span>
  //             </td>
  //           </tr>
  //         );
  //       })}
  //       <tr>
  //         <td css={[tableCell]} colSpan="5"></td>
  //       </tr>

  //       <tr>
  //         <td colSpan="4" align="right">
  //           <span>Total Amount</span>
  //         </td>
  //         <td data-testid="total_amount">
  //           <span>
  //             <strong>{formatDigits(customer.total_amount)}</strong>
  //           </span>
  //         </td>
  //       </tr>

  //       <tr>
  //         <td colSpan="4" align="right">
  //           <span>Amount Received</span>
  //         </td>
  //         <td data-testid="paid_amount">
  //           <span>
  //             <strong>{formatDigits(customer.amount_paid+customer.balance)}</strong>
  //           </span>
  //         </td>
  //       </tr>
  //       <tr>
  //         <td colSpan="4" align="right">
  //           <span>Change</span>
  //         </td>
  //         <td data-testid="paid_amount">
  //           <span>
  //             <strong>{formatDigits(customer.balance)}</strong>
  //           </span>
  //         </td>
  //       </tr>
  //       <tr>
  //         <td colSpan="4" align="right">
  //           <span>Total Discount</span>
  //         </td>
  //         <td data-testid="discount">
  //           <span>
  //             <strong>{formatDigits(customer.total_discount)}</strong>
  //           </span>
  //         </td>
  //       </tr>
  //     </tbody>
  //   </ItemsTable>
  // );
  const itemDetails = (
    <ItemsTable headData={headData} css={{ border: "1px solid #ccc", borderCollapse: "collapse",color: "#000",width: "100%" }}>
      <thead>
        <tr>
          <th
            css={{
              border: "1px solid #ccc",
              padding: "8px",
              textAlign: "left",
              backgroundColor: "#f9f9f9",
              color: "#000",
            }}
          >
            Brand Name
          </th>
          <th
            css={{
              border: "1px solid #ccc",
              padding: "8px",
              textAlign: "center",
              backgroundColor: "#f9f9f9",
            }}
          >
            Qty
          </th>
          <th
            css={{
              border: "1px solid #ccc",
              padding: "8px",
              textAlign: "center",
              backgroundColor: "#f9f9f9",
            }}
          >
            Rate
          </th>
          <th
            css={{
              border: "1px solid #ccc",
              padding: "8px",
              textAlign: "right",
              backgroundColor: "#f9f9f9",
            }}
          >
            Amount
          </th>
        </tr>
      </thead>
  
      <tbody>
        {products.map((info, index) => {
          const qty = info.quantity ? +info.quantity : 0;
          const rate = info.rate ? +info.rate : 0;
          const discount = info.discount_amount ? +info.discount_amount : 0;

          const final_rate = rate - discount;
          const total = final_rate * qty;

  
          return (
            <tr key={index}>
              <td
                css={{ border: "1px solid #ccc", padding: "8px", wordBreak: "break-word" }}
                data-testid={`product_name-${index}`}
              >
                {info.product_name}
              </td>
  
              <td
                css={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}
                data-testid={`quantity-${index}`}
              >
                {qty}
              </td>
  
              <td
                css={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}
                data-testid={`rate-${index}`}
              >
                {formatDigits(final_rate)}
              </td>
  
              <td
                css={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }}
                data-testid={`total_rate-${index}`}
              >
                {formatDigits(total)}
              </td>
            </tr>
          );
        })}
  
        {/* Empty Row for spacing */}
        <tr>
          <td colSpan="4" css={{ border: "none", height: "10px" }}></td>
        </tr>
  
        {/* Total Amount */}
        <tr>
          <td colSpan="3" css={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }}>
            Total Amount
          </td>
          <td css={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }} data-testid="total_amount">
            <strong>{formatDigits(customer.total_amount)}</strong>
          </td>
        </tr>
  
        {/* Amount Received */}
        <tr>
          <td colSpan="3" css={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }}>
            Amount Received
          </td>
          <td css={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }} data-testid="paid_amount">
            <strong>{formatDigits(customer.amount_paid + customer.balance)}</strong>
          </td>
        </tr>
  
        {/* Change */}
        <tr>
          <td colSpan="3" css={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }}>
            Change
          </td>
          <td css={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }} data-testid="change">
            <strong>{formatDigits(customer.balance)}</strong>
          </td>
        </tr>
  
        {/* Discount */}
        {/* <tr>
          <td colSpan="3" css={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }}>
            Total Discount
          </td>
          <td css={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }} data-testid="discount">
            <strong>{formatDigits(customer.total_discount)}</strong>
          </td>
        </tr> */}
      </tbody>
    </ItemsTable>
  );
  

  return <ReceiptTemplate {...{ customerDetails, itemDetails }} />;
};

export { SalesReceiptTemplate };
